import React from 'react';

const StarOutlineICon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.99794 11.8336L3.88327 13.997L4.66927 9.41496L1.33594 6.17029L5.93594 5.50363L7.99327 1.33496L10.0506 5.50363L14.6506 6.17029L11.3173 9.41496L12.1033 13.997L7.99794 11.8336Z'
        stroke='#BFBFBF'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default StarOutlineICon;
